import React from 'react';
import './PremiumLoader.css';

const PremiumLoader = ({ message = "Loading..." }) => {
    return (
        <div className="premium-loading-wrapper">
            <div className="premium-loading-card">
                <div className="premium-spinner"></div>
                <p className="premium-loading-text">{message}</p>
            </div>
        </div>
    );
};

export default PremiumLoader;
